
export default function MenuArrow({className}) {
    return (
        <svg className={className} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" style={{fill: 'none', strokeWidth:20, strokeLinecap:'round', strokeMiterlimit:10}}>
            <path d="M41.92,115.43l50.89-50.89c0.45-0.45,0.45-1.19,0-1.64l-50.4-50.4"/>
        </svg>
    )
}
